import { render } from "./DatasourceFileList.vue?vue&type=template&id=8b1c03d2&scoped=true&ts=true"
import script from "./DatasourceFileList.vue?vue&type=script&lang=ts"
export * from "./DatasourceFileList.vue?vue&type=script&lang=ts"

import "./DatasourceFileList.vue?vue&type=style&index=0&id=8b1c03d2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1c03d2"]])

export default __exports__